import {
  ApprovalStage,
  PresentationalStateAction,
  PresentationalStateActions,
  TransactionState,
  TransactionalState,
  PriceImpactState,
} from './interface'

import { initialPresentationalState } from './defaults'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function presentationalStateReducer(
  state: TransactionalState = initialPresentationalState,
  action: PresentationalStateAction,
) {
  //FIXME returned value have to be typed
  switch (action.type) {
    /**
     * ============================================================
     * Price impact
     * ============================================================
     */
    case PresentationalStateActions.ACKNOWLEDGE_PRICE_IMPACT:
      return { ...state, ...{ priceImpactState: PriceImpactState.ACKNOWLEDGED } }
    case PresentationalStateActions.WARN_PRICE_IMPACT:
      return { ...state, ...{ priceImpactState: PriceImpactState.WARN } }
    case PresentationalStateActions.RESET_PRICE_IMPACT:
      return { ...state, ...{ priceImpactState: PriceImpactState.NONE } }
    case PresentationalStateActions.SET_PRICE_IMPACT:
      return { ...state, ...{ currentPriceImpactPercentage: action.payload } }

    /**
     * ============================================================
     * Dollar values
     * ============================================================
     */
    case PresentationalStateActions.SET_INPUT_DOLLAR_VALUE:
      return { ...state, ...{ inputDollarValue: action.payload } }
    case PresentationalStateActions.SET_OUTPUT_DOLLAR_VALUE:
      return { ...state, ...{ outputDollarValue: action.payload } }

    /**
     * ============================================================
     * Submit transaction states
     * ============================================================
     */
    case PresentationalStateActions.SUBMIT_TRANSACTION:
      return { ...state, transactionState: TransactionState.SUBMITTED }
    case PresentationalStateActions.SUBMITTING_TRANSACTION:
      return { ...state, transactionState: TransactionState.SUBMITTING }
    case PresentationalStateActions.SUCCESS_TRANSACTION:
      return { ...state, transactionState: TransactionState.SUCCESS }
    case PresentationalStateActions.FAILURE_TRANSACTION:
      return { ...state, transactionState: TransactionState.FAILURE }
    case PresentationalStateActions.RESET_TRANSACTION:
      return { ...state, transactionState: TransactionState.IDLE }
    case PresentationalStateActions.APPROVE_TRANSACTION:
      return { ...state, transactionState: TransactionState.APPROVE }

    /**
     * ===========================================================
     * Toggle button states
     * ===========================================================
     */
    case PresentationalStateActions.CHANGE_TAB_BUY:
      return {
        ...state,
        ...{ isBuying: true, priceImpactState: PriceImpactState.NONE, outputDollarValue: '0' },
      }
    case PresentationalStateActions.CHANGE_TAB_SELL:
      return {
        ...state,
        ...{ isBuying: false, priceImpactState: PriceImpactState.NONE, outputDollarValue: '0' },
      }

    /**
     * ===========================================================
     * Tokens received modal states
     * ===========================================================
     */
    case PresentationalStateActions.OPEN_TOKENS_RECEIVED_MODAL:
      return { ...state, ...{ isTokensReceivedModalOpen: true } }
    case PresentationalStateActions.CLOSE_TOKENS_RECEIVED_MODAL:
      return { ...state, ...{ isTokensReceivedModalOpen: false } }

    /**
     * ===========================================================
     * Modal States Used by Underlay component to render/not
     * ===========================================================
     */
    case PresentationalStateActions.OPEN_MODAL:
      return { ...state, ...{ modalOpen: true } }
    case PresentationalStateActions.CLOSE_MODAL:
      return { ...state, ...{ modalOpen: false } }

    /**
     * ===========================================================
     * Request approval states
     * ===========================================================
     */
    case PresentationalStateActions.REQUEST_APPROVAL:
      return { ...state, ...{ approvalState: ApprovalStage.PENDING } }
    case PresentationalStateActions.REQUESTED_APPROVAL:
      return { ...state, ...{ approvalState: ApprovalStage.REQUESTED } }
    case PresentationalStateActions.RESPONSE_APPROVAL:
      return {
        ...state,
        ...{ approvalState: action.payload ? ApprovalStage.APPROVED : ApprovalStage.REJECTED },
      }

    /**
     * ===========================================================
     * Fee input states
     * ===========================================================
     */
    case PresentationalStateActions.CHANGE_FEE:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Amount input actions must contain a payload')
      }
      return { ...state, ...{ fee: action.payload } }

    /**
     * ===========================================================
     * Amount input states
     * ===========================================================
     */
    case PresentationalStateActions.CHANGE_BUY_INPUT_AMOUNT:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Amount input actions must contain a payload')
      }
      return { ...state, ...{ inputAssetAmount: action.payload } }

    case PresentationalStateActions.CHANGE_SELL_INPUT_AMOUNT:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Amount input actions must contain a payload')
      }
      return { ...state, ...{ inputIndexAmount: action.payload } }

    /**
     * ===========================================================
     * Sets the transaction hash to the latest one submitted
     * ===========================================================
     */
    case PresentationalStateActions.SET_TRANSACTION:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Transaction hash action must have a payload')
      }
      return { ...state, ...{ transaction: action.payload } }

    case PresentationalStateActions.RUNNING_TRANSACTION:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Transaction running action must have a payload')
      }
      return { ...state, ...{ runningTransaction: action.payload } }

    /**
     * ===========================================================
     * Advanced setting states
     * ===========================================================
     */
    case PresentationalStateActions.SET_TRANSACTION_TYPE:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Advanced setting actions must contain a payload')
      }
      return { ...state, ...{ transactionType: action.payload } }
    case PresentationalStateActions.SET_REDEMPTION_ASSET:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Advanced setting actions must contain a payload')
      }
      return { ...state, ...{ redemptionAsset: action.payload } }
    case PresentationalStateActions.SET_SLIPPAGE_TOLERANCE:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Advanced setting actions must contain a payload')
      }
      return { ...state, ...{ slippageTolerance: action.payload, autoSlippage: false } }
    case PresentationalStateActions.SET_AUTO_SLIPPAGE:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Advanced setting actions must contain a payload')
      }
      return { ...state, ...{ autoSlippage: action.payload } }

    /**
     * ===========================================================
     * New states made by glkvskiy
     * ===========================================================
     */

    case PresentationalStateActions.SET_SELECTED_ASSET:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Select asset actions must contain a payload')
      }
      return { ...state, ...{ selectedAsset: action.payload } }

    case PresentationalStateActions.SET_RECEIVED_TOKENS: {
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Amount input actions must contain a payload')
      }
      const { receivedTokens, outputDollarValue } = action.payload
      return { ...state, ...{ receivedTokens, outputDollarValue } }
    }
    case PresentationalStateActions.SET_LOADING_FOR_VALUES:
      if (action.payload === undefined || action.payload === null) {
        throw new Error('Amount input actions must contain a payload')
      }
      return { ...state, ...{ loadingValues: action.payload } }
    /**
     * ===========================================================
     * Catch any other actions as errors
     * ===========================================================
     */
    default:
      throw new Error(`Unknown type provided to presentationalStateReducer: ${action.type}`)
  }
}
